import { createFileRoute } from "@tanstack/react-router";

import { PendingTransactions } from "../-components/PendingTransactions";

export const Route = createFileRoute("/_authenticated/trade/pending/")({
  component: PendingTransactions,
  context: () => ({ permissions: "trade.pending" }),
});
